namespace Gordic.Vyp.Dlg
{
    const { gcontent } = Decorators

    @gcontent
    export class EditacePolozkyCenikuDlg extends GContentBase
    {
        model: Wfl.Interface.GCenikPostyDetailDto;
        validators: any;

        onContentReady()
        {
            var l_labelNazev = "";
            switch (this.model.typ) {
                case Gordic.Wfl.Interface.TypCenikuPosty.cenikPostovnichSluzeb:
                    l_labelNazev = "jres:23900090";
                    break;
                case Gordic.Wfl.Interface.TypCenikuPosty.cenikZasilek:
                    l_labelNazev = "jres:23900097"; //RC 23900097 : Druh zásilky
                    break;
            }
            const form = new Gordic.Forms.Form({ name: "FormEdit", layoutDescriptor: "L1M1S1" });
            form.addSection();
            form.addRow(l_labelNazev)
                .addField("gstringbox", { name: "nazev", model: "model.nazev = value", disabled: true })

            form.addRow("jres:23900100") //RC 23900100 : Váha od - do
                .addField("gnumberbox", "w-6", { name: "vaha_od", model: "model.vaha_od = value", disabled: true, decimals: 2 }, )
                .addField("gnumberbox", "w-6", { name: "vaha_do", model: "model.vaha_do = value", disabled: true, decimals: 2 }); 

            form.addRow("jres:23900017") //RC 23900017 : Cena
                .addField("gnumberbox", { name: "cena", model: "model.cena = value", decimals: 3 })

            this.defaultForm = $("<div>").appendTo(this.element).gform("createFrom", form);
            this.findFields().gfield("model", "apply", this.model).gfield("model", "validators", this.validators);
            this.findFields("cena").gfield("focus");          
        }       

        OKClick()
        {
            const that = this;
            if (this.defaultForm)
            {
                if (!this.defaultForm.gform("isValid")) return;
                this.findFields().gfield("model", "collect", this.model);
                this.call<boolean>("SaveData", { model: that.model })
                    .done(function (data) {
                        that.close(that.model);   
                    })
                    .always(function () {
                        that.endOperation();
                    });
            }       
        }
    }
}